import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link, stripLangPrefix } from "../i18n/LangContext";
import { useTranslation } from "react-i18next";
import LogoWhite from "../assets/images/logo_white_transparent.png";
import LanguageSwitcher from "./LanguageSwitcher";
import { BookButton } from "./CtaPair";

const NAV = [
  { path: "/", key: "home" },
  { path: "/offers", key: "offers" },
  { path: "/about", key: "about" },
  { path: "/career", key: "career" },
  { path: "/playground", key: "playground" },
  { path: "/stories", key: "stories" },
  { path: "/contact", key: "contact" },
];


const Header = () => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const pathname = stripLangPrefix(location.pathname);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".header_section");
      if (window.scrollY > 50) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className="header_section">
      <div className="container-fluid">
        <nav
          className={`navbar navbar-expand-lg custom_nav-container ${
            menuOpen ? "lg_nav-toggle" : ""
          }`}
        >
          <Link className="navbar-brand" to="/">
            <img
              src={LogoWhite}
              alt="MALI Labs Logo"
              style={{ objectFit: "contain", width: "auto" }}
            />
            <span>M<span className="ai-rainbow">A</span>L<span className="ai-rainbow">I</span> Labs</span>
          </Link>

          <span className="message">{t("nav.tagline")}</span>

          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleMenu}
            aria-controls="navbarSupportedContent"
            aria-expanded={menuOpen ? "true" : "false"}
            aria-label={t("nav.toggle")}
          ></button>

          <div
            className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ml-auto">
              {NAV.map(
                ({ path, key }, index) => (
                  <li
                    key={path}
                    className={`nav-item ${
                      pathname === path ||
                      (path === "/stories" && pathname.startsWith("/stories"))
                        ? "active"
                        : ""
                    }`}
                    style={{ "--i": index }}
                  >
                    <Link className="nav-link" to={path}>
                      {t(`nav.${key}`)}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="d-flex align-items-center">
            <BookButton short className="header-cta" />
            <LanguageSwitcher />
            <div className="custom_menu-btn">
              <button
                type="button"
                onClick={toggleMenu}
                aria-label={t("nav.toggle")}
                aria-expanded={menuOpen}
              >
                <span className={`s-1 ${menuOpen ? "open" : ""}`}></span>
                <span className={`s-2 ${menuOpen ? "open" : ""}`}></span>
                <span className={`s-3 ${menuOpen ? "open" : ""}`}></span>
              </button>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
